<script>
import { localeState, setAppLocale } from "@app/store/localeStore.svelte.js";
import Menu from "../menu/Menu.svelte";
import MenuItem from "../menu/MenuItem.svelte";
import * as m from "@app/paraglide/messages.js";
</script>

<Menu
    id="language"
    label={localeState.current.toUpperCase()}
    ariaLabel={m.language_selection()}
    alignEnd>
    <MenuItem
        label={m.english()}
        id="langEnBtn"
        checked={localeState.current === "en"}
        onSelect={() => setAppLocale("en")} />
    <MenuItem
        label={m.french()}
        id="langFrBtn"
        checked={localeState.current === "fr"}
        onSelect={() => setAppLocale("fr")} />
    <MenuItem
        label={m.german()}
        id="langDeBtn"
        checked={localeState.current === "de"}
        onSelect={() => setAppLocale("de")} />
    <MenuItem
        label="Italiano"
        id="langItBtn"
        checked={localeState.current === "it"}
        onSelect={() => setAppLocale("it")} />
    <MenuItem
        label="Русский"
        id="langRuBtn"
        checked={localeState.current === "ru"}
        onSelect={() => setAppLocale("ru")} />
    <MenuItem
        label="Español"
        id="langEsBtn"
        checked={localeState.current === "es"}
        onSelect={() => setAppLocale("es")} />
    <MenuItem
        label="简体中文"
        id="langZhCnBtn"
        checked={localeState.current === "zh-CN"}
        onSelect={() => setAppLocale("zh-CN")} />
    <MenuItem
        label="日本語"
        id="langJaBtn"
        checked={localeState.current === "ja"}
        onSelect={() => setAppLocale("ja")} />
    <MenuItem
        label="हिन्दी"
        id="langHiBtn"
        checked={localeState.current === "hi"}
        onSelect={() => setAppLocale("hi")} />
    <MenuItem
        label="Português (Portugal)"
        id="langPtPtBtn"
        checked={localeState.current === "pt-PT"}
        onSelect={() => setAppLocale("pt-PT")} />
</Menu>
